import script from "./RadioButtonThemeQuestion.vue?vue&type=script&lang=ts&setup=true"
export * from "./RadioButtonThemeQuestion.vue?vue&type=script&lang=ts&setup=true"

import "./RadioButtonThemeQuestion.vue?vue&type=style&index=0&id=294b888d&lang=scss"
import "./RadioButtonThemeQuestion.vue?vue&type=style&index=1&id=294b888d&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\TelAvivMuseum.Web\\museum-telaviv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-294b888d"]])

export default __exports__